import * as Sentry from '@sentry/react';
import React from 'react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';
import { env } from '@config/env';

/**
 * Initialize Sentry only in staging / production. Replay defaults to maskAllText:
 * true so admin/order data cannot leak via session replay (per MIGRATION_PLAN.md §1).
 */
export function initSentry(): void {
  if (!(env.isProduction || env.isStaging)) return;
  if (!env.VITE_SENTRY_DSN) return;

  Sentry.init({
    dsn: env.VITE_SENTRY_DSN,
    environment: env.isProduction ? 'production' : 'staging',
    sendDefaultPii: false,
    attachStacktrace: true,
    integrations: [
      Sentry.reactRouterV7BrowserTracingIntegration({
        useEffect: React.useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.replayIntegration({
        maskAllText: true,
        maskAllInputs: true,
        blockAllMedia: true,
      }),
    ],
    tracesSampleRate: env.isProduction ? 0.1 : 0.25,
    replaysSessionSampleRate: env.isProduction ? 0.05 : 0.2,
    replaysOnErrorSampleRate: 1.0,
  });
}
